<template>
<div class="form-group">
  <label>Troca de Geladeiras</label>
  <br>
  <span
    v-for="(image, index) in imagesMap.refrigerators"
    :key="image"
  >
      <input
        type="radio"
        name="refrigerator_icon"
        :value="value"
        @input="$emit('input', image)"
        :checked="image === value"
      />
      <img
        :src="imagesMap.basePath + image"
        :alt="'refrigerator icon' + index"
      >
    </span>
  <br>
  <label>Caminhões</label>
  <br>
  <span
    v-for="(image, index) in imagesMap.trucks"
    :key="image"
  >
      <input
        type="radio"
        name="refrigerator_icon"
        :value="value"
        @input="$emit('input', image)"
        :checked="image === value"
      />
      <img
        :src="imagesMap.basePath + image"
        :alt="'refrigerator icon' + index"
      >
    </span>
  <br>
  <label>Agentes</label>
  <br>
  <span
    v-for="(image, index) in imagesMap.personas"
    :key="image"
  >
      <input
        type="radio"
        name="refrigerator_icon"
        :value="value"
        @input="$emit('input', image)"
        :checked="image === value"
      />
      <img
        :src="imagesMap.basePath + image"
        :alt="'refrigerator icon' + index"
      >
    </span>
</div>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
  name: 'InputRadioIconRefrigeratoMap',
  props: ['value'],
  computed: {
    ...mapGetters('eventsSpecifications', ['imagesMap'])
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Trg/EventsSpecifications/InputRadioIconRefrigeratoMap.vue